import { css } from "styled-components";

const typography = css`
  body {
    /* font-family: "Montserrat", sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export default typography;
